import {
  parlerApiPath,
  parlerbotApiPath,
  parlerbotProxyV1,
} from './api.js';

export {
  parlerApiPath,
  parlerbotApiPath,
  parlerbotProxyV1,
};

export function mediaImageProxyUrl(businessPhoneId, assetId) {
  const bp = String(businessPhoneId || '').trim();
  const id = String(assetId || '').trim();
  if (!bp || !id) return '';
  return parlerbotProxyV1(
    `/business-phones/${encodeURIComponent(bp)}/media/images/${encodeURIComponent(id)}`,
  );
}

function hasProtocol(value) {
  return value.startsWith('http://') || value.startsWith('https://');
}

function asString(value) {
  return typeof value === 'string' ? value.trim() : '';
}

export function appPath(path = '/') {
  const raw = asString(path);
  if (!raw || raw === '/') return '/';
  if (hasProtocol(raw)) return raw;
  const normalized = raw.startsWith('/') ? raw : `/${raw}`;
  return normalized;
}

export function getAPP_ROOT_PATH() {
  return '/';
}

export const APP_ROUTES = Object.freeze({
  get root()        { return '/'; },
  get dashboard()   { return appPath('/dashboard'); },
  get summary()     { return appPath('/summary'); },
  get whatsapp()    { return appPath('/whatsapp'); },
  get invoice()     { return appPath('/invoice'); },
  get templates()   { return appPath('/templates'); },
  get crm()         { return appPath('/crm'); },
  get scheduler()   { return appPath('/scheduler'); },
  get clients()     { return appPath('/clients'); },
  get overview()    { return appPath('/overview'); },
  get knowledgeBase() { return appPath('/knowledge-base'); },
  get login()       { return appPath('/login'); },
  get register()    { return appPath('/register'); },
  get profile()     { return appPath('/profile'); },
  get admin()       { return appPath('/admin'); },
  get connect()     { return appPath('/connect'); },
  get kb()          { return appPath('/kb/'); },
});

export { parlerApiPath as apiPath } from './api.js';
